import React from "react";
import "./App.css";
import Board from "./containers/Board";

function App() {
  return (
    <div className="App">
      <Board />
    </div>
  );
}

export default App;
